import React, { useState } from 'react';

import ListResource from './ListResource.jsx';
import ListCtrlActivates from './ListCtrlActivates.jsx';

const api = '/api/site/horses';

const bloodlines = ['Areo', 'Darley', 'Hayato',"Byerley","Godolphin","Blood"];

const clsLvs = [1, 2, 3, 4, 5, 6];

const ListHorses = () => {
  const filter = {};
  const [bloodline, setBloodline] = useState('');
  const [clsLv, setClsLv] = useState('');

  const aCond = [];

  if (bloodline) {
    aCond.push({ bloodline });
  }
  if (clsLv) {
    aCond.push({ clsLv });
  }
  if (aCond.length > 0) {
    filter.$and = aCond;
  }

  return (
    <ListResource
      {...{
        searchable: true,
        api,
        actions: {
          create: false,
          fileExport: true,
        },
        sort: { horseId: 1 },
        filter,
        cols: [
          { key: 'horseId', sortable: true, children: 'Horse ID' },
          { key: 'name', sortable: true, children: 'Name' },
          { key: 'mint', sortable: true, children: 'Mint' },

          { key: 'bloodline', sortable: true },
          // { key: 'horsePics.src', sortable: true, children: 'Pics' },
        ],
        ctrls: [
          <select
            className="custom-select"
            key={0}
            value={bloodline}
            onChange={(e) => setBloodline(e.target.value)}
          >
            <option value="">All</option>
            {bloodlines.map((a) => (
              <option key={a} value={a}>
                {a}
              </option>
            ))}
          </select>,
          <select
            className="custom-select"
            key={1}
            value={clsLv}
            onChange={(e) => setClsLv(e.target.value)}
          >
            <option value="">All</option>
            {clsLvs.map((a) => (
              <option key={a} value={a}>
                Class {a}
              </option>
            ))}
          </select>,
        ],
      }}
    >
      {({ selected, refresh }) => (
        <ListCtrlActivates api={api} selected={selected} onSuccess={refresh} />
      )}
    </ListResource>
  );
};

export default ListHorses;
